<template>
  <a
    :href="href"
    class="gh-button-email">
    <slot>
      <v-icon>send</v-icon> {{ emailAddress }}
    </slot>
  </a>
</template>

<script>
export default {
  name: 'gh-button-email',

  props: {
    emailAddress: {
      type: String
    }
  },

  computed: {
    href () {
      return `mailto:${this.emailAddress}`
    }
  }
}
</script>

<style lang="sass" scoped>
  .gh-button-email
    text-decoration: none
    display: inline-block
</style>
